import {
  ConversationSummaryVisibilityState,
  ConversationTranslationVisibilityState,
} from './types/userStorage.types';

export const summaryVisibilityStateDefault: ConversationSummaryVisibilityState =
  {
    email: 'on-demand',
    interactivechat: 'on-demand',
    messaging: 'on-demand',
    speak: 'auto',
  };

export const translationVisibilityStateDefault: ConversationTranslationVisibilityState =
  {
    email: 'on-demand',
    interactivechat: 'on-demand',
    messaging: 'on-demand',
  };

export const copilotPreferredLanguageDefault = 'en';

// Defaults for new agents created after cutoff date
export const cutoffDateForNewAgentsDefaults = new Date('2025-10-29T00:00:00Z');

export const summaryVisibilityStateDefaultAfterCutoffDate: ConversationSummaryVisibilityState =
  {
    email: 'auto',
    interactivechat: 'auto',
    messaging: 'auto',
    speak: 'auto',
  };

export const translationVisibilityStateDefaultAfterCutoffDate: ConversationTranslationVisibilityState =
  {
    email: 'auto',
    interactivechat: 'auto',
    messaging: 'auto',
  };
